import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  SKYCLUB_FEATURE_KEY,
  State,
  skyClubAdapter
} from '../reducers/sky-club.reducer';

import * as Adapters from '../../adapters';
import { getFullPageError } from '../../adapters/full-page-error.adapter';

// Lookup the 'SkyClub' feature state managed by NgRx
export const getSkyClubState =
  createFeatureSelector<State>(SKYCLUB_FEATURE_KEY);

const { selectEntities } = skyClubAdapter.getSelectors();

export const getSkyClubEntities = createSelector(
  getSkyClubState,
  (state: State) => selectEntities(state)
);

export const getTitle = createSelector(getSkyClubEntities, (skyClubContent) =>
  Adapters.getTitle(skyClubContent['aem-content']?.aemContent?.title)
);

export const getOverview = createSelector(
  getSkyClubEntities,
  (skyClubContent) =>
    Adapters.getOverview(
      skyClubContent['aem-content']?.aemContent?.overview,
      undefined,
      true,
      skyClubContent['purchase-data']?.purchaseData
    )
);

export const getPurchase = createSelector(
  getSkyClubEntities,
  (skyClubContent) =>
    Adapters.getPurchase(
      skyClubContent['aem-content']?.aemContent?.purchase,
      skyClubContent['purchase-data']?.purchaseData?.membershipDetailMap,
      skyClubContent['aem-content']?.aemContent?.errorMessages,
      [skyClubContent['purchase-data-error']?.purchaseDataError],
      true
    )
);

export const getCheckout = createSelector(
  getSkyClubEntities,
  (skyClubContent) =>
    Adapters.getCheckout(
      skyClubContent['aem-content']?.aemContent?.checkout,
      skyClubContent['add-to-cart-data']?.addToCart,
      skyClubContent['add-to-cart-data']?.value,
      skyClubContent['aem-content']?.aemContent?.errorMessages,
      [skyClubContent['add-to-cart-error']?.addToCartError],
      true
    )
);

export const getFullPageErrorMessage = createSelector(
  getSkyClubEntities,
  (skyClubContent) =>
    getFullPageError([skyClubContent['aem-content-error']?.aemContentError])
);
